<template>
  <detail-layout-full-width>
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
          <div class="lg:max-w-detail lg:mr-auto">
              <div class="mt-2">
                <el-table
                  ref="metadatos"
                  :data="form.Metadatos"
                  style="width: 100%"
                  :show-header="true">
                  <el-table-column
                    prop="Campo"
                    label="Metadato"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="actions"
                    width="80"
                    align="center"
                    label="-">
                    <template slot-scope="scope">
                    <div class="flex flex-row">
                      <base-button-icon @click="deleteMetadatoAdicional(scope.row)" name="trash" mode="core" size="xs" ariaLabel="Eliminar metadato adicional"/>
                    </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
          </div>
        </el-form>
      </div>
      </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="primary"
            :text="$t('notificationFilter.new_metadata')"
            icon="plus"
            @click="newMetadato()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
      <input-select-all-metadata-by-client-dialog
        :dialogOpen="showNewMetadato" 
        @toggleDialog="toggleDialogMetadato" 
        @applyDialog="applyDialogMetadatoHandler"
        :values="metadatos"
      />
    </template>
  </detail-layout-full-width>
</template>

<script>
import DetailLayoutFullWidth from '../../components/layout/DetailLayoutFullWidth.vue'
import { getApiRequest } from '@/services/configurations/rules/getApiRequest'
import { getmetadatosobligatoriospeticionapi } from '@/services/configurations/rules/getmetadatosobligatoriospeticionapi'
import { deletemetadatoobligatorio } from '@/services/configurations/rules/deletemetadatoobligatorio' 
import { agregarmetadatoobligatorio } from '@/services/configurations/agregarmetadatoobligatorio'  
import { getcamposmetadatosall } from '@/services/clients/lists/getcamposmetadatosall'
import { i18n } from '@/i18n'
import BaseFooter from '../../components/base/BaseFooter.vue'
import InputSelectAllMetadataByClientDialog from '../../components/InputSelectAllMetadataByClientDialog.vue'

export default {
  /* eslint-disable camelcase */
  name: 'metadata-by-api-request',
  components: {
    DetailLayoutFullWidth,
    BaseFooter,
    InputSelectAllMetadataByClientDialog,
  },
  data: function () {
    return {
      activeName: 'es',
      header: {
        title: i18n.t('app.apirequest_metadata_title'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'configurations/apirequests/details',
      },
      showNewMetadato: false,
      numMaxMetadata: 50,
      form: {
        Metadatos: [],
        idCliente: -1,
      },
      metadatos: [],
      rules: {}
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    id () {
      return parseInt(this.$route.params.id)
    }
  },
  created: async function () {
    const breadcrumbs = []
    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      breadcrumbs.push({
        path: this.role === 'SuperAdministrador' ? 'configurationssa' : 'configurations',
        name: this.$i18n.t('app.configurations')
      })
    } else {
      breadcrumbs.push({
        path: 'configurations',
        name: this.$i18n.t('app.configurations')
      })
    }
    breadcrumbs.push({ path: 'configurations/apirequests', name: this.$i18n.t('app.apirequests') })
    const data = await this.downloadDataApiRequest(this.id)
    this.form.idCliente = data.idCliente
    breadcrumbs.push({ path: '', name: data.NombreAccion })
    this.$store.commit('app/setheaderBreadCrumb', data.NombreAccion)

    this.header.breadcrumb = breadcrumbs

    await this.downloadData()
    await this.downloadDataMetadatosAll()
  },
  mounted () {
  },
  methods: {
    toggleDialogMetadato: function () {
      this.showNewMetadato = !this.showNewMetadato
    },
    newMetadato: async function () {
      this.toggleDialogMetadato()
    },
    applyDialogMetadatoHandler: async function (payload) {
      try {
        this.$store.commit('app/setLoading', true)
        const response = await agregarmetadatoobligatorio({ Campo: payload, idPeticion: this.id })
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.downloadData()
          this.toggleDialogMetadato()
          this.doFeedback('Metadato añadido correctamente', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    deleteMetadatoAdicional: async function (row) {
      try {
        this.$store.commit('app/setLoading', true)
        const response = await deletemetadatoobligatorio({ idPeticionMetadato: row.idPeticionMetadato })
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.downloadData()
          this.doFeedback('Metadato eliminado correctamente', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    ///
    downloadDataApiRequest: async function (idPeticion) {
      let apiRquest = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idPeticion: idPeticion
        }
        apiRquest = await getApiRequest(params)
        if (apiRquest.blnError) {
          this.doFeedback(apiRquest.msgError + ' [Código de error: ' + apiRquest.codError + ']')
        }
        return apiRquest.respuesta
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadData: async function () {
      try {
        const params = { idPeticion: this.id }
        const result = await getmetadatosobligatoriospeticionapi(params)
        if (result.blnError) {
          this.doFeedback(result.msgError + ' [Código de error: ' + result.codError + ']')
        } else {
          this.form.Metadatos = result.respuesta
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    downloadDataMetadatosAll: async function () {
      try {
        const params = { idCliente: this.form.idCliente }
        const result = await getcamposmetadatosall(params)
        if (result.blnError) {
          this.doFeedback(result.msgError + ' [Código de error: ' + result.codError + ']')
        } else {
          this.metadatos = result.Respuesta
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
  }

}
</script>
